import React from 'react'
import { VStack, Text } from '@chakra-ui/react'
import AppNotificationItem from './AppNotificationItem'

const NotificationsList = ({ notifications }) => {
  if (notifications.length) {
    return (
      <VStack align="stretch" spacing="2">
        {notifications.map((item, index) => (
          <AppNotificationItem data={item} key={index} />
        ))}
      </VStack>
    )
  }
  return (
    <VStack spacing="1" py="4" minW="200px" justify="center">
      <Text fontSize="sm">No notifications for now</Text>
      <Text fontSize="xs" color="brand.muted">
        check later!
      </Text>
    </VStack>
  )
}

export default NotificationsList
